import React from "react"
import StarFullImage from "../../static/images/star_full.svg"

class Comment extends React.Component {
  render() {
    const { stars } = this.props
    let starsElements = []

    if (!stars) return null

    for (let index = 0; index < stars; index++) {
     starsElements.push((
      <img
        src={StarFullImage}
        alt={`rating star ${index}`}
        key={`star-${index}`}
      />
     ))
    }

    return (
      <div className="star-rating">
        { starsElements }
      </div>
    )
  }
}

export default Comment
